import { Button, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from '../../i18n/useTranslation';

type Props = {
    onCloseModal: () => void;
    onOk?: (result: string) => void;
    title?: string;
    defaultValue?: string;
};

export const EditTextModal = ({ defaultValue, onCloseModal, onOk, title }: Props) => {
    const { t } = useTranslation();
    const [stagedValue, setStagedValue] = useState(defaultValue || '');
    return (
        <Modal
            visible
            centered
            keyboard
            title={title}
            className="f-modal"
            onCancel={onCloseModal}
            footer={
                <>
                    <Button onClick={onCloseModal} type="default">
                        {t('Cancel')}
                    </Button>
                    <Button
                        type="primary"
                        data-testid="edit-text-done-btn"
                        disabled={stagedValue.trim().length === 0}
                        onClick={() => onOk?.(stagedValue)}
                    >
                        {t('Done')}
                    </Button>
                </>
            }
        >
            <Input
                aria-label={`${t('Filter by')} ${title}`}
                data-testid="edit-text-input"
                onChange={(e) => setStagedValue(e.target.value)}
                value={stagedValue}
            />
        </Modal>
    );
};
